import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import moment from 'moment'
import R from 'ramda'
import { push } from 'react-router-redux'
import { Table, TableCell, TableHeader, TableExpander } from 'advenio-components'
import { Form } from 'formsy-react'
import ChildByClassroom from './ChildByClassroom'
import LoadingSpinner from '../../Components/LoadingSpinner'
import Subcomponent from './Subcomponent'
import Percentage from '../../Components/ReportsComponents/Percentage'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: block;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
`
const CenterContainer = styled.div`
  width: 100%;
  flex-direction: column;
`
const Center = styled.span`
  font-weight: bold;
  font-size: 20px;
  margin-right: 20px;
`
const CenterTitle = styled(Form)`
  width: 90%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
`
const Info = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  align-items: center;
  margin-bottom: 20px;
`
const Card = styled.div`
  width: ${props => props.large ? '400px' : '180px'};
  height: 150px;
  background: #FFFFFF;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: space-between;
  margin-right: 5px;
  padding: 16px;
  flex-direction: column;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 1024px) {
    width: ${props => props.large ? '300px' : '130px'};
  }
`
const TableContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  height: 100%;
  width: 100%;
`
const ReportCard = styled.div`
  width: 800px;
  height: 300px;
  background: #FFFFFF;
  display: flex;
  align-items: flex-start;
  padding: 16px;
  box-sizing: border-box;
  flex-direction: column;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  @media (max-width: 1024px) {
    width: 600px;
  }
`
const PhoneCard = styled.div`
  width: 400px;
  height: 300px;
  background: #FFFFFF;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #C4CDD5;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 6px;
  @media (max-width: 1024px) {
    width: 300px;
  }
`
const MedicineCard = styled(PhoneCard)`
  height: 150px;
`
const PhoneContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow-y: auto;
`
const MedicineContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: #CCCCCC;
`
const TitleContainer = styled.div`
  padding: 16px;
`
const Line = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  background: ${props => props.isWhite ? '#FFFFFF' : '#f7f7f7'};
`
const PhoneName = styled.div`
  font-weight: bold;
  color: #3E4757;
`
const PhoneNumber = styled(PhoneName)`
  opacity: .5;
`
const CardTitle = styled.span`
  font-size: 14px;
  color: #919EAB;
  font-weight: bold;
  @media (max-width: 1024px) {
    font-size: 12px;
  }
`
const CardData = styled.span`
  font-size: 48px;
  font-weight: bold;
  color: #3E4757;
  @media (max-width: 1024px) {
    font-size: 36px;
  }
`

class Overview extends Component {
  state = {
    data: {},
  }

  componentWillMount() {
    const { getCentersInfo, activeCenter, match, setCenter } = this.props

    if (match && match.params) {
      setCenter(match.params.centerId)
      getCentersInfo(match.params.centerId, 'overview')
    } else if (activeCenter !== 0) {
      getCentersInfo(activeCenter, 'overview')
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.centersInfo) {
      this.setState({ data: nextProps.centersInfo })
    }
  }

  getPhoneNumbers = () => {
    const { data } = this.state
    if (data.emergency_numbers) {
      const numbers = data.emergency_numbers.map((currentValue, index) => {
        return (
          <Line key={index} isWhite={(index + 1) % 2 === 0}>
            <PhoneName>{currentValue.name}</PhoneName>
            <PhoneNumber>{currentValue.tel}</PhoneNumber>
          </Line>
        )
      })
      return numbers
    }
    return (
      <div />
    )
  }

  getMedicines = () => {
    const { data } = this.state
    if (data.medications_due_today) {
      const medications = data.medications_due_today.map((currentValue, index) => {
        return (
          <Line key={index} isWhite={(index + 1) % 2 === 0} >
            <PhoneName>{currentValue.student.full_name}</PhoneName>
            <PhoneNumber>{moment(currentValue.apply_at, 'HH:mm:ss').format('hh:mm A')}</PhoneNumber>
          </Line>
        )
      })
      if (data.medications_due_today.length > 0) {
        return medications
      }
      return (
        <span>No hay medicamentos por aplicar hoy</span>
      )
    }
    return (
      <div />
    )
  }

  render() {
    const { data } = this.state
    return (
      <Container>
        {!R.isEmpty(data) ?
          <CenterContainer>
            {!this.props.fromCenter && (
              <CenterTitle>
                <Center>{`Resumen - ${data.name} (${data.abbreviation})`}</Center>
              </CenterTitle>
            )}
            <Info>
              <Card>
                <CardTitle>
                  ACTIVOS
                </CardTitle>
                <CardData>
                  {data.active_count}
                </CardData>
                <Percentage />
              </Card>
              <Card>
                <CardTitle>
                  CHECKED OUT
                </CardTitle>
                <CardData>
                  {data.checked_out_count}
                </CardData>
                <Percentage />
              </Card>
              <Card>
                <CardTitle>
                  SALA DE SINTOMAS
                </CardTitle>
                <CardData>
                  {data.sick_room_count}
                </CardData>
                <Percentage />
              </Card>
              <Card>
                <CardTitle>
                  CENTRO VIRTUAL
                </CardTitle>
                <CardData>
                  {data.virtual_center_count}
                </CardData>
                <Percentage />
              </Card>
              <MedicineCard>
                <TitleContainer>
                  <CardTitle>
                    MEDICAMENTOS
                  </CardTitle>
                </TitleContainer>
                <MedicineContainer>
                  {this.getMedicines()}
                </MedicineContainer>
              </MedicineCard>
            </Info>
            <CenterTitle>
              <Center>El Centro</Center>
            </CenterTitle>
            <Info>
              <ReportCard>
                <CardTitle>
                  NIÑOS POR SALA
                </CardTitle>
                <ChildByClassroom data={data.classrooms} />
              </ReportCard>
              <PhoneCard>
                <TitleContainer>
                  <CardTitle>
                    TELEFONOS DE EMERGENCIA
                  </CardTitle>
                </TitleContainer>
                <PhoneContainer>
                  {this.getPhoneNumbers()}
                </PhoneContainer>
              </PhoneCard>
            </Info>
          </CenterContainer>
          :
          <LoadingSpinner />
        }
      </Container>
    )
  }
}


const mapStateToProps = ({ centersInfo, auth }) => ({
  centersInfo: centersInfo.overview.results,
  activeCenter: centersInfo.center,
  user: auth.user,
})

const mapDispatchToProps = dispatch => ({
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
  goTo: link => dispatch(push(link)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Overview)



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/Overview.jsx